module.exports = {"batches":{"name":"Semesters","desc":"Semesters that the student registered."},"results":{"name":"Semester Results","courseCode":"Course Code","courseName":"Course Name","attendance":"Attendance","seven":"7th<span class='hidden-xs'> Week (30%)","twelve":"12th <span class='hidden-xs'> Week (20%)","work":"<span class='hidden-xs'> Semeter Work (10%)","final":"Final Grade"},"achievement":{"desc":"Semster Achievement","term":"Semester Achievement","total":"Total Achievement","credit":"Credit Achieved","gpa":"G.P.A"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/results/Lang/en.json
// module id = 70
// module chunks = 0